import React, { useEffect, useRef, useState } from "react";
import "./Fintech.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Fintech = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Digital Banking Solutions",
      description:
        "Consultation on modern digital banking platforms and infrastructure",
      whatsappMessage:
        "Hello, I'm interested in Digital Banking Solutions consultation.",
    },
    {
      id: 2,
      title: "Payment Processing",
      description: "Expert advice on payment gateways, processors, and systems",
      whatsappMessage:
        "Hello, I'm interested in Payment Processing consultation.",
    },
    {
      id: 3,
      title: "Blockchain & Crypto",
      description:
        "Guidance on blockchain implementation and cryptocurrency solutions",
      whatsappMessage:
        "Hello, I'm interested in Blockchain & Crypto consultation.",
    },
    {
      id: 4,
      title: "Financial Analytics",
      description:
        "Leveraging data analytics for financial insights and decision making",
      whatsappMessage:
        "Hello, I'm interested in Financial Analytics consultation.",
    },
    {
      id: 5,
      title: "Regulatory Compliance",
      description:
        "Navigating financial regulations and compliance requirements",
      whatsappMessage:
        "Hello, I'm interested in Regulatory Compliance consultation.",
    },
    {
      id: 6,
      title: "Wealth Management Tech",
      description: "Technology solutions for wealth and asset management firms",
      whatsappMessage:
        "Hello, I'm interested in Wealth Management Tech consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="fintech-page">
      <Helmet>
        <title>
          Fintech Solutions | Cutting-edge Financial Technology Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive fintech solutions powered by the latest technologies including blockchain, AI, and mobile development frameworks."
        />
        <meta
          name="keywords"
          content="fintech, financial technology, blockchain development, AI in finance, mobile banking solutions, cryptocurrency, ethereum, hyperledger, react native, flutter, angular, nodejs, digital payments, financial software, wealthtech, regtech, insurtech, payment processing, financial analytics, digital banking, financial apps, financial APIs, open banking, smart contracts, decentralized finance, financial security, financial data, trading platforms, investment technology, peer-to-peer lending, financial inclusion, digital wallets, financial UX, financial cloud, quantum finance, financial machine learning, algorithmic trading, financial compliance, robo-advisors, financial dashboard, banking as a service, financial infrastructure"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="fintech-hero">
        <div className="fintech-hero-content">
          <h1 className="fintech-hero-title">
            Revolutionizing{" "}
            <span className="fintech-highlight">Financial Technology</span>
          </h1>
          <p className="fintech-hero-description">
            We deliver cutting-edge fintech solutions that transform how
            businesses and consumers interact with financial services. From
            digital banking to blockchain and AI-powered analytics.
          </p>
          <div className="fintech-hero-buttons">
            <a href="/contact-us">
              <button className="fintech-btn fintech-btn-primary">
                Get Started
              </button>
            </a>
            <button className="fintech-btn fintech-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="fintech-hero-visual">
          <div className="fintech-animated-card">
            <div className="fintech-card-chip"></div>
            <div className="fintech-card-line"></div>
            <div className="fintech-card-line short"></div>
            <div className="fintech-card-dots">
              <div className="fintech-card-dot"></div>
              <div className="fintech-card-dot"></div>
              <div className="fintech-card-dot"></div>
              <div className="fintech-card-dot"></div>
            </div>
          </div>
          <div className="fintech-orb fintech-orb-1"></div>
          <div className="fintech-orb fintech-orb-2"></div>
          <div className="fintech-orb fintech-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="fintech-services">
        <div className="fintech-services-header">
          <h2 className="fintech-section-title">Our Fintech Solutions</h2>
          <p className="fintech-section-subtitle">
            Cutting-edge financial technology services designed to transform
            your business operations, enhance customer experiences, and drive
            growth in the digital economy.
          </p>
        </div>

        <div className="fintech-services-grid">
          {/* Blockchain & Cryptocurrency Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-blockchain"></div>
            </div>
            <h3>Blockchain & Cryptocurrency</h3>
            <p>
              Secure, transparent distributed ledger solutions for payments,
              smart contracts, and digital assets.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Smart Contract Development</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Tokenization Solutions</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>DeFi Platform Development</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>NFT Marketplace Development</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">85%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Transaction Processing</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Digital Banking Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-mobilebanking"></div>
            </div>
            <h3>Digital Banking</h3>
            <p>
              Next-generation mobile and online banking platforms with seamless
              user experiences.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Mobile Banking Apps</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Online Account Opening</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Loan Origination</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Biometric Authentication</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Faster Onboarding</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Uptime Guarantee</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* AI-Powered Analytics Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-ai"></div>
            </div>
            <h3>AI-Powered Analytics</h3>
            <p>
              Intelligent fraud detection, risk assessment, and personalized
              financial recommendations.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Fraud Detection Systems</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Credit Risk Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Customer Behavior Insights</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Accuracy Rate</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Fraud Prevention</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Payment Solutions Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-payment"></div>
            </div>
            <h3>Payment Solutions</h3>
            <p>
              Faster, more secure payment processing systems with multiple
              integration options.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Payment Gateway Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Mobile Wallet Solutions</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Cross-Border Payments</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-Time Settlement</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">2.5s</div>
                <div className="stat-label">Avg. Processing Time</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">256-bit</div>
                <div className="stat-label">Encryption</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* RegTech Solutions Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-regtech"></div>
            </div>
            <h3>RegTech Solutions</h3>
            <p>
              Compliance and regulatory technology to navigate complex financial
              regulations efficiently.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>AML Compliance Systems</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>KYC Verification</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Transaction Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Regulatory Reporting</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">70%</div>
                <div className="stat-label">Faster Compliance</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Audit Ready</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Wealth Management Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-wealth"></div>
            </div>
            <h3>Wealth Management</h3>
            <p>
              Digital wealth management platforms and robo-advisors for modern
              investment strategies.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Robo-Advisory Platforms</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Portfolio Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Investing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Tax-Loss Harvesting</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Higher Returns</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">0.25%</div>
                <div className="stat-label">Management Fee</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* InsurTech Solutions Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-insurtech"></div>
            </div>
            <h3>InsurTech Solutions</h3>
            <p>
              Technology-driven insurance solutions for automated underwriting,
              claims processing, and customer management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Underwriting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Claims Processing AI</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Usage-Based Insurance</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Policy Management</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Claims</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">20%</div>
                <div className="stat-label">Lower Premiums</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Lending Technology Card */}
          <div className="fintech-service-card">
            <div className="fintech-service-icon">
              <div className="fintech-icon fintech-icon-lending"></div>
            </div>
            <h3>Lending Technology</h3>
            <p>
              Digital lending platforms with automated credit decisions, risk
              assessment, and loan management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Credit Scoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Peer-to-Peer Lending</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Loan Management Systems</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Alternative Data Analysis</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">5min</div>
                <div className="stat-label">Loan Approval</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Lower Default Rates</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="fintech-services-cta">
          <h3>Ready to transform your financial services?</h3>
          <p>
            Schedule a free consultation with our fintech experts to discuss
            your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="fintech-consultation-container">
              <button
                className="fintech-primary-btn fintech-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="fintech-modal-overlay">
                  <div className="fintech-modal-content">
                    <button
                      className="fintech-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="fintech-modal-title">
                      FinTech Consultation Services
                    </h2>
                    <p className="fintech-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="fintech-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`fintech-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="fintech-option-title">
                            {option.title}
                          </h3>
                          <p className="fintech-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`fintech-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="fintech-btn fintech-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="fintech-stats">
        <div className="fintech-stats-container">
          <div className="fintech-stat">
            <h3 className="fintech-stat-number" data-count="250">
              250
            </h3>
            <p className="fintech-stat-label">Fintech Projects</p>
          </div>
          <div className="fintech-stat">
            <h3 className="fintech-stat-number" data-count="98">
              197
            </h3>
            <p className="fintech-stat-label">Client Satisfaction</p>
          </div>
          <div className="fintech-stat">
            <h3 className="fintech-stat-number" data-count="15">
              11
            </h3>
            <p className="fintech-stat-label">Years Experience</p>
          </div>
          <div className="fintech-stat">
            <h3 className="fintech-stat-number" data-count="40">
              40
            </h3>
            <p className="fintech-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="fintech-cta">
        <div className="fintech-cta-content">
          <h2>Ready to Transform Your Financial Services?</h2>
          <p>
            Contact us today to discuss how our fintech expertise can help your
            business innovate and grow.
          </p>
          <a href="/contact-us">
            <button className="fintech-btn fintech-btn-primary fintech-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Fintech;
